(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["winter-header"]) return;
  try {
    
if (!customElements.get('winter-navigation-controller')) {
  class WinterNavigationController extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const header = this.closest('[data-winter-header]');
      if (!header) return;
      const closeMenus = () => header.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) closeMenus();
      }, options);
      document.addEventListener('focusin', event => {
        if (!header.contains(event.target)) closeMenus();
      }, options);
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = event.target.closest('details[open]');
        if (current) {
          current.open = false;
          current.querySelector('summary').focus();
          event.preventDefault();
          event.stopPropagation();
        }
      }, options);
      header.querySelectorAll('.winter-submenu').forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          const nav = detail.closest('nav');
          nav.querySelectorAll('.winter-submenu[open]').forEach(other => {
            if (other !== detail) other.open = false;
          });
        }, options);
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('winter-navigation-controller', WinterNavigationController);
}
document.querySelectorAll('[data-winter-header]').forEach(header => {
  if (!header.querySelector('winter-navigation-controller')) header.append(document.createElement('winter-navigation-controller'));
});
document.addEventListener('shopify:section:load', event => {
  const header = event.target.querySelector('[data-winter-header]');
  if (header && !header.querySelector('winter-navigation-controller')) header.append(document.createElement('winter-navigation-controller'));
});

  } catch(e) { console.error(e); }
})();
})();
